// extracted by mini-css-extract-plugin
module.exports = {"container":"Tag_container__3u6rH","label":"Tag_label__1R1Ay","counter":"Tag_counter__2L8oN","info":"Tag_info__3LS_o","normal":"Tag_normal__21bnm","active":"Tag_active__1Gkz4"};